// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// import VueLocalStorage from "vue-localstorage";
// Vue.use(VueLocalStorage);

import vueConfig from "./basics/vue-config";
Vue.use(vueConfig);

// 全局过滤器
import * as customFilters from "@/basics/filters";
Object.keys(customFilters).forEach(key => {
	Vue.filter(key, customFilters[key]);
});

import router from "./basics/router";
import store from "./basics/store";

import Element from "element-ui";
import "./assets/scss/main.scss";

Vue.use(Element);

import customFields from "./components/index";

Object.keys(customFields).forEach(key => {
	Vue.component(key, customFields[key]);
});

//ajax 基础
import fetch from "./basics/fetch";

window.$http = fetch;

Vue.prototype.$axios = window.$http;

//router 控制
router.beforeEach((to, from, next) => {
	let gotoLoginPage = false;

	if (to.meta.requireLogin) {
		let isLogin = store.state.isLogin;
		if (!isLogin) {
			store.commit("checkLogin");
		}
		isLogin = store.state.isLogin;
		if (!isLogin) {
			gotoLoginPage = true;
		}
	}
	if (gotoLoginPage) {
		next({
			path: "/user/login",
			query: { redirect: to.fullPath }
		});
	} else {
		if (to.meta.noMenu) {
			store.commit("setMenu", { show: false });
		} else {
			store.commit("setMenu", {
				show: true,
				mainMenuActiveIndex: to.meta.menuIndex
			});
		}
		next();
	}
});

import App from "./App";

/* eslint-disable no-new */
window.instance = new Vue({
	el: "#app",
	router,
	store,
	components: { App },
	render: h => h(App) ,
});
